import React from "react";

const IconShoppingCart = ({ color = "#e31c19" }) => {
  return (
    <svg
      id="UI_icon_cart_light"
      data-name="UI icon/cart/light"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Path_Stroke_"
        data-name="Path (Stroke)"
        d="M15.4,14H7.562a3,3,0,0,1-2.911-2.273L2.408,2.758A1,1,0,0,0,1.438,2H1A1,1,0,0,1,1,0h.438A3,3,0,0,1,4.349,2.273L4.531,3H16.507a3,3,0,0,1,2.929,3.651l-1.111,5A3,3,0,0,1,15.4,14ZM5.031,5l1.561,6.242a1,1,0,0,0,.97.757H15.4a.994.994,0,0,0,.976-.783l1.111-5A1,1,0,0,0,16.507,5Z"
        transform="translate(2 3)"
        fill={color}
      />
      <path
        id="Oval"
        d="M1.5,3A1.5,1.5,0,1,0,0,1.5,1.5,1.5,0,0,0,1.5,3Z"
        transform="translate(8 18)"
        fill={color}
      />
      <path
        id="Oval_Copy"
        data-name="Oval Copy"
        d="M1.5,3A1.5,1.5,0,1,0,0,1.5,1.5,1.5,0,0,0,1.5,3Z"
        transform="translate(16 18)"
        fill={color}
      />
    </svg>
  );
};

export default IconShoppingCart;
